var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticStyle:{"margin-top":"100px"}},[_c('Ficha')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }